module.exports = __webpack_public_path__ + "static/media/pattern-view-iconV2.389f550c.svg";